import * as React from 'react';
import cx from 'classnames';
import { getTestAttributes } from '@common/utils/tests';
import { MODULE_NAME } from '@modules/fhq-design-tool/constants/shared';
import { Field, FieldError } from '../field';
import { IInputComponent } from '@modules/fhq-design-tool/types/input-component';
import TreeDropdown from '@common/components/TreeDropdown';
import { FolderPrimaryListDto } from '@common/dto/folder/primary-list-dto';
import { Loading } from '@common/components/loading';

import './folder-picker.styles.scss';

export type FolderPickerProps = IInputComponent<FolderPrimaryListDto['id'] | undefined, FolderPrimaryListDto['id']> & {
  labelWidth?: number | string;
  label: string;
  folders: Array<FolderPrimaryListDto>;
  errors?: Array<FieldError>;
};

export const FolderPicker: React.FC<FolderPickerProps> = (props) => {
  const { errors, className, disabled, label, labelWidth, onChange, value, metadata, description, required, margin, folders } = props;

  return (
    <Field 
      labelWidth={labelWidth} 
      label={label} 
      disabled={disabled}
      className={cx('FhqDesignToolFolderPicker', className)}
      description={description}
      required={required}
      margin={margin}
      errors={errors}
    >
      {folders.length
        ? (
          <TreeDropdown
            className="FhqDesignToolFolderPicker__component"
            items={folders}
            classes={{
              menu: 'FhqDesignToolFolderPicker__component__menu'
            }}
            value={value}
            onChange={onChange}
            {...getTestAttributes(MODULE_NAME, metadata.description, 'folder-select')}
          />
        )
        : <Loading size={30} />
      }
    </Field>
  );
};